<template lang="pug">
.modal-window(role="dialog" :aria-labelledby="uniqueId")
	button.modal-window__close.js-close-modal(type="button" aria-label="Закрыть")
		.modal-window__close-text Закрыть
		v-svg-icon.modal-window__close-icon(icon="close")
	.modal-window__body
		slot
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	data() {
		return {
			uniqueId: uniqueId('modal_'),
			active: true
		};
	}
};
</script>

